type Config = {
  ZAPEHR_ACCESS_TOKEN: string;
  ZAPEHR_PROJECT_ID?: string | undefined;
  ZAPEHR_FHIR_API_URL?: string | undefined;
  ZAPEHR_PROJECT_API_URL?: string | undefined;
};

let globalConfig: Config;

export function getConfig(): Config {
  if (!globalConfig) {
    throw new Error('Config not set, please initialize the SDK');
  }
  return globalConfig;
}

export function setConfig(config: Config): void {
  globalConfig = { ...config };
}
